export default function StarBoldIcon() {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.3904 5.21L16.8004 8.03C16.9904 8.42 17.5004 8.79 17.9304 8.87L20.4804 9.29C22.1104 9.56 22.4904 10.74 21.3204 11.92L19.3304 13.91C19.0004 14.24 18.8104 14.89 18.9204 15.36L19.4904 17.82C19.9404 19.76 18.9004 20.52 17.1904 19.5L14.8004 18.08C14.3704 17.82 13.6504 17.82 13.2204 18.08L10.8304 19.5C9.12043 20.51 8.08043 19.76 8.53043 17.82L9.10043 15.36C9.19043 14.88 9.00043 14.23 8.67043 13.9L6.68043 11.91C5.51043 10.74 5.89043 9.56 7.52043 9.28L10.0704 8.86C10.5004 8.79 11.0104 8.41 11.2004 8.02L12.6104 5.2C13.3804 3.68 14.6204 3.68 15.3904 5.21Z"
          className={"svg-fill"}
        />
        <path
          d="M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z"
          className={"svg-fill"}
        />
        <path
          d="M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z"
          className={"svg-fill"}
        />
        <path
          d="M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z"
          className={"svg-fill"}
        />
      </svg>
    </>
  );
}
